import React, { Fragment, useState, useEffect, useContext } from 'react'
import moment from 'moment'
import { store } from '../../../../../context/StateProvider'
import Table2 from '../../../../templates/components/Table2'
import Utilities from "../../../../../services/commonservice/utilities";
import InvoiceService from "../../../../../services/api/invoice.service";
import ChartNotesService from "../../../../../services/api/chart-notes.service";
import SoapNotesService from '../../../../../services/api/soapnotes.service';
import AppointmentService from "../../../../../services/api/appointment.service";
import { useGetLocationProviderServices, useGetLocationServiceTypes } from "../../../../../services/cache/CacheService";

const PatientActivitySummary = (props) => {

    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const patientId = props.patientId;
    const patientName = props.patientName;
    const patientPhone = props.patientPhone;
    const stateDoctorList = useGetLocationProviderServices();
    const stateServiceTypeList = useGetLocationServiceTypes()

    const [isLoader, setIsLoader] = useState(false);
    const [practiceLocationId, setPracticeLocationId] = useState()
    const [practiceLocation, setPracticeLocation] = useState()
    const [invoiceProductList, setInvoiceProductList] = useState([]);
    const [appointmentList, setAppointmentList] = useState([]);
    const [invoiceServicesList, setInvoiceServicesList] = useState([]);
    const [chartNotesList, setChartNotesList] = useState([]);
    const [soapNotesList, setSoapNotesList] = useState([]);

    const [providersList, setProvidersList] = useState([])
    const [practiceServiceTypeList, setPracticeServiceTypeList] = useState([])

    useEffect(() => {
        if (state?.practiceLocationId) {
            setPracticeLocationId(state.practiceLocationId);

            const matched = state?.practiceLocations.find(
                (loc) => loc.practiceLocationId === state.practiceLocationId
            );

            if (matched) {
                setPracticeLocation(matched.practiceLocation);
            }
        }
    }, [state?.practiceLocationId]);

    useEffect(() => {
        if (practiceLocationId) {
            loadAllData();
        }
    }, [practiceLocationId]);

    useEffect(async () => {
        if (stateDoctorList) {
            setProvidersList(stateDoctorList)
        }
    }, [stateDoctorList]);
    useEffect(async () => {
        if (stateServiceTypeList) {
            setPracticeServiceTypeList(stateServiceTypeList)
        }
    }, [stateServiceTypeList]);

    

    const loadAllData = async () => {
        setIsLoader(true);
        try {
            await Promise.all([
                getInvoiceProducts(),
                getInvoiceServices(),
                getAppointments(),
                getChartNotes(),
                getSoapNotes()
            ]);
        } catch (err) {
            console.error("Error loading data:", err);
        } finally {
            setIsLoader(false);
        }
    };

    const getAppointments = () => {
        setIsLoader(true);
        const reqObj = {
            PatientIds: patientId,
            Location: practiceLocationId,
            SortField: 'CreatedOn',
            Asc: 'false',
            PageSize: 10,
            StartRow: 0
        };
        return AppointmentService.findAppointment(reqObj)
            .then((res) => {
                const arr = Array.isArray(res) ? res : [];
                const sorted = arr
                    .filter((a) => a?.id)
                    .sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate))
                    .slice(0, 5)
                setAppointmentList(sorted);
                setIsLoader(false);
            })
            .catch(() => { setAppointmentList([]); setIsLoader(false); });
    };

    const getInvoiceProducts = () => {
        setIsLoader(true);
        const reqObj = {
            PatientId: patientId,
            PracticeLocationId: practiceLocationId,
            ItemTypeId: 1,
            InvoiceStatusId: 9,
            SortField: 'CreatedOn',
            Asc: 'false',
            PageSize: 10,
            StartRow: 0
        };
        return InvoiceService.getInvoiceItemsReport(reqObj)
            .then((res) => {
                const items = res?.data?.data || [];
                setInvoiceProductList(items);
                setIsLoader(false);
            })
            .catch((err) => {
                console.error("getInvoiceProducts error:", err);
                setInvoiceProductList([]);
                setIsLoader(false);
            });
    };

    const getInvoiceServices = () => {
        setIsLoader(true);
        const reqObj = {
            PatientId: patientId,
            PracticeLocationId: practiceLocationId,
            ItemTypeId: 2,
            InvoiceStatusId: 9,
            SortField: 'CreatedOn',
            Asc: 'false',
            PageSize: 10,
            StartRow: 0
        };
        return InvoiceService.getInvoiceItemsReport(reqObj)
            .then((res) => {
                const items = res?.data?.data || [];
                setInvoiceServicesList(items);
                setIsLoader(false);
            })
            .catch((err) => {
                console.error("getInvoiceServices error:", err);
                setInvoiceServicesList([]);
                setIsLoader(false);
            });
    };

    const getChartNotes = () => {
        setIsLoader(true);
        const reqObj = {
            PatientIds: patientId,
            SortField: 'CreatedOn',
            Asc: 'false',
            PageSize: 10,
            StartRow: 0
        };

        return ChartNotesService.getChartNotes(reqObj)
            .then(res => {
                const notes = res?.data || [];
                setChartNotesList(notes);
                setIsLoader(false);
            })
            .catch((err) => {
                console.error("getChartNotes error:", err);
                setChartNotesList([]);
                setIsLoader(false);
            });
    };

    const getSoapNotes = () => {
        setIsLoader(true);
        const reqObj = {
            PatientId: patientId,
            PracticeLocationId: practiceLocationId,
            SortField: 'CreatedOn',
            Asc: 'false',
            PageSize: 10,
            StartRow: 0
        };
        return SoapNotesService.findSoapNotes(reqObj)
            .then((res) => {
                const notes = res?.data || [];
                setSoapNotesList(notes);
                setIsLoader(false);
            })
            .catch((err) => {
                console.error("getSoapNotes error:", err);
                setSoapNotesList([]);
                setIsLoader(false);
            });
    };

    const serviceHeader = React.useMemo(() => {
        if (!Array.isArray(props.data)) return 'Service';

        const hasProduct = props.data.some(row => row.itemTypeId === 1);
        const hasService = props.data.some(row => row.itemTypeId === 2);

        if (hasProduct) return 'Product';
        if (hasService) return 'Service';
        return 'Product/Service';
    }, [props.data]);

    const print = () => {
        Utilities.printWindow('PatientSummary', 'PatientSummary', { landscape: false })
    }

    const appoinmentColumns = [
        {
            id: "date",
            Header: "Appointment Date",
            accessor: (row) => {
                let dateText = row.fromDate ? moment(row.fromDate).format("MM-DD-YYYY") : "";
                if (row.providerRequested === 1) {
                    dateText = "R " + dateText;
                }
                return dateText;
            }
        },
        {
            id: "time",
            Header: "Time",
            accessor: (row) => {
                return row.fromDate ? `${moment(row.fromDate).format('h:mm')}-${moment(row.toDate).format('h:mm A')}` : ""
            }
        },
        {
            id: "practiceServiceType",
            Header: "Service",
            accessor: (row) => {
                let service = row.practiceServiceType || ""
                if (!row.parentGroupId) {
                    service = service + " (Main)";
                }
                return service;
            }
        },
        {
            id: "doctorId",
            Header: "Staff",
            accessor: (row) => row.drFirstName ? `${row.drFirstName} ${row.drLastName}` : ""
        },
        {
            id: "room",
            Header: "Room",
            accessor: (row) => row.room || "",
        },
        {
            id: "finalAmount",
            Header: "Total Price",
            accessor: (row) => row.finalAmount
        },
        {
            id: "amountPaid",
            Header: "Amount Paid",
            accessor: (row) => row.amountPaid,
        },
        {
            id: "appointmentStatusCode",
            Header: "Status",
            accessor: (row) => row.appointmentStatusCode || "",
        },
    ];

    const invoiceItemsColumns = React.useMemo(
        () => [
            {
                id: 'service',
                Header: serviceHeader,
                accessor: row => row.productOrService || ''
            },
            {
                id: "invoiceNumber",
                Header: "Invoice Number",
                accessor: (row) => row.invoiceNumber,
            },
            {
                id: "invoiceDate",
                Header: "Invoice Date",
                accessor: (row) => {
                    return row.invoiceDate ? moment(row.invoiceDate).format("MM-DD-YYYY") : ''
                },
            },
            {
                id: "unitPrice",
                Header: "Unit Price",
                accessor: (row) => { return Utilities.toDollar(row.unitPrice) },
            },
            {
                id: 'qty',
                Header: 'Qty',
                accessor: row => row.quantity ?? 0,
            }
        ],
        [serviceHeader]
    );

    const chartColumns = [
        {
            id: "appointmentDate",
            Header: "Appointment Date",
            accessor: (row) => {
                return row.appointmentDate ? moment(row.appointmentDate).format("MM-DD-YYYY") : ""
            }
        },
        {
            id: "doctorId",
            Header: "Provider",
            accessor: (row) => {
                let selectedDoctor = providersList?.find((obj) => obj.id === row.doctorId)
                return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : ""
            }
        },
        {
            id: "practiceServiceType",
            Header: "Service",
            accessor: (row) => {
                let service = practiceServiceTypeList?.find(obj => obj.practiceServiceTypeId === row.practiceServiceTypeId)
                if (service) return service.practiceServiceType
                return ''
            }
        },
        {
            id: "notes",
            Header: "Notes",
            accessor: (row) => row.notes,
        },
    ];
    const soapColumns = [
        {
            id: 'plan',
            Header: 'Plan',
            accessor: row => row.plan || '',
            Cell: ({ value }) => <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>
        },
        {
            id: 'subjective',
            Header: 'Subjective',
            accessor: row => row.subjective || '',
            Cell: ({ value }) => <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>
        },
        {
            id: 'objective',
            Header: 'Objective',
            accessor: row => row.objective || '',
            Cell: ({ value }) => <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>
        },
        {
            id: 'assessment',
            Header: 'Assessment',
            accessor: row => row.assessment || '',
            Cell: ({ value }) => <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>
        },
        {
            id: 'createdOn',
            Header: 'Created Date',
            accessor: row =>  row.createdOn ? moment(row.createdOn).format("MM-DD-YYYY") : ""
        }
    ];
    return (
        <Fragment>
            {isLoader && (
                <div className="ui">
                    <div className="ui active dimmer">
                        <div className="ui indeterminate text loader">{'Please be patient while data loads..'}</div>
                    </div>
                </div>
            )}
            {!isLoader && (
                <div className='row d-flex justify-content-end'>
                <div className='col-auto mb-3'>
                    <button className="btn btn-primary" title="Print" onClick={e => { e.preventDefault(); print() }}><i className='icon file print' /></button>
                </div>
            </div>
            )}
            <div id="PatientSummary" title="PatientSummary" className='container-fluid strong-border '>
           
                <div className="col-md-12 shadow-sm mt-1 p-1">
                    <div className="row">
                        <div className="col-6">
                            <strong>
                                Patient: {patientName}{patientPhone ? ` | ${patientPhone}` : ''}
                            </strong>
                        </div>
                        <div className="col-6 text-end">
                            <strong>
                                Practice Location: {practiceLocation}
                            </strong>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 shadow-sm mt-1 p-1" >
                    <Table2
                        data={appointmentList}
                        columns={appoinmentColumns}
                        loading={isLoader}
                        showFooter={false}
                    />
                </div>

                <div className="row mt-3 g-3">
                    <div className="col-md-6 shadow-sm mt-1 p-1 strong-border">
                        <h6 style={{ textAlign: 'left', margin: '6px 0', fontWeight: 700 }}>Product History</h6>
                        <Table2
                            data={invoiceProductList}
                            columns={invoiceItemsColumns}
                            loading={isLoader}
                            showFooter={false}
                        />
                    </div>

                    <div className="col-md-6 shadow-sm mt-1 segment p-1">
                        <h6 style={{ textAlign: 'left', margin: '6px 0', fontWeight: 700 }}>Service History</h6>
                        <Table2
                            data={invoiceServicesList}
                            columns={invoiceItemsColumns}
                            loading={isLoader}
                            showFooter={false}
                        />
                    </div>
                </div>

                <div className="row mt-3 g-3">
                    <div className="col-md-6 shadow-sm mt-1 segment p-1">
                        <h6 style={{ textAlign: 'left', margin: '6px 0', fontWeight: 700 }}>Chart Notes</h6>
                        <Table2
                            data={chartNotesList}
                            columns={chartColumns}
                            loading={isLoader}
                            showFooter={false}
                        />
                    </div>

                    <div className="col-md-6 shadow-sm mt-1 segment p-1">
                        <h6 style={{ textAlign: 'left', margin: '6px 0', fontWeight: 700 }}>SOAP Notes</h6>
                        <Table2
                            data={soapNotesList}
                            columns={soapColumns}
                            loading={isLoader}
                            showFooter={false}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PatientActivitySummary;
